import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { checkSession } from "./lib/auth";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Review from "./pages/Review";

function AdminRoute({ children }) {
  const [session, setSession] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    (async () => {
      const s = await checkSession();
      setSession(s);
      setChecked(true);
    })();
  }, []);

  if (!checked) return <div className="min-h-screen flex items-center justify-center"><div className="title-pop text-2xl" style={{ color: "var(--ff-peach)" }}>A carregar...</div></div>;
  if (!session) return <Navigate to="/admin/login" replace />;
  return <>{children}</>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/avaliar/:token" element={<Review />} />
          <Route path="/validate/:token" element={<Review />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
